import { ThemeProvider } from "styled-components"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import theme from "./theme"
import ResetStyle from "./theme/reset"
import "./theme/font.css"

import Style from "./style"
import AlertModal from "./ui/AlertModal"
import ConfirmModal from "./ui/ConfirmModal"
import Footer from "./ui/Footer"

import usePutAccountPremiumCheck from "entity/account/usePutAccountPremiumCheck"

import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useConfirmModalAtom from "shared/model/useConfirmModalAtom"

import Page from "page"
import { useState } from "react"
import Maintenance from "./ui/Maintenance"
import useLoginCookie from "shared/model/useLoginCookie"

const App = () => {
    const [isMaintenance, setIsMaintenance] = useState(
        process.env.REACT_APP_MAINTENANCE === "true"
      );

      const navigate = useNavigate()
    
    const { pathname } = useLocation()

    const [isAlertModalView] = useAlertModalAtom()
    const [isConfrimModalView] = useConfirmModalAtom()
    const [, , deleteLoginCookie] = useLoginCookie()

    usePutAccountPremiumCheck()


    useEffect(() => {
        if(isMaintenance){
            deleteLoginCookie()
            navigate("/")
        }
    }, [])


    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return (
            <ThemeProvider theme={theme}>
        {isMaintenance ? (
            <Maintenance setIsMaintenance={setIsMaintenance} />
        ) : (
            <>
            <ResetStyle />
            <Style.ParentWrapper>
                {isAlertModalView && <AlertModal />}
                {isConfrimModalView && <ConfirmModal />}
                <Page />
                <Footer />
            </Style.ParentWrapper>
            </>
        )}
        </ThemeProvider> 
      
    )
}

export default App